// tslint:disable: quotemark
export enum ActivationEnum {
	Organization = 0,
	User = 1,
	Site = 2,
	Event = 3
}

export namespace ActivationEnum {
	export function toDescription(val: ActivationEnum) {
		switch (val) {
			case 0:
				return "Organization";
			case 1:
				return "User";
			case 2:
				return "Site";
			case 3:
				return "Event";
		}
		return null;
	}
}